import { render } from "./AdminMain.vue?vue&type=template&id=3ab7d19f&scoped=true"
import script from "./AdminMain.vue?vue&type=script&lang=js"
export * from "./AdminMain.vue?vue&type=script&lang=js"

import "./AdminMain.vue?vue&type=style&index=0&id=3ab7d19f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab7d19f"]])

export default __exports__